import {secured as axios} from "../../../axios"

class ServiceQuery {
  static url = '/services'

  static mapServiceData(service, variant) {
    console.log('------', variant);
    const imageUrl = service?.image ? process.env.REACT_APP_API_BASE_URL + '/' + service.image.uri :
        process.env.REACT_APP_API_BASE_URL + '/assets/img/advice1.png';
    return {
      ...service,
      title: service.title.text,
      description: service.rich_text,
      image: imageUrl,
      presentation: service.type,
      isFavorite: service.isFavorite,
      treading: false,
      variant: variant,
      variantName: variant == 'service' ? 'Service' : 'Conseil',
    }
  }

  static async findAll() {
    return await axios.get(this.url)
        .then(res => {
          return res.data.map((data) => this.mapServiceData(data, 'service'))
        })
  }

  static async findById(id) {
    const list = await this.findAll();

    return list.filter((service) => service.id === id)[0];
  }

  static async addToFavorite(id, variant) {
    return await axios.post(`/${variant}/${id}/favorite`);
  }

  static async removeFromFavorite(id, variant) {
    return await axios.delete(`/${variant}/${id}/favorite`)
  }

  static async getServiceByCommunity(communityId) {
    return await axios.get(`/community/${communityId}/service`).then(res => {
      return res.data.map((data) => this.mapServiceData(data, 'service'))
    })
  }

  static async getAdviceByCommunity(communityId) {
    return await axios.get(`/community/${communityId}/advice`).then(res => {
      return res.data.map((data) => this.mapServiceData(data, 'advice'))
    })
  }
}

export { ServiceQuery };
